import React from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { ResponsiveBar } from "@nivo/bar";
import SectionTitle from "../../SectionTitle";
import Utilities from "../../../../lib/Utilities";
import { ChartDefaultOption } from "../../../../lib/CommonUI";
import TableBody from "@material-ui/core/TableBody";

const util = new Utilities();

export default React.memo(StatementOfFinancialPosition);
function StatementOfFinancialPosition(props) {
  const { compInfo, isExistData, isPrint } = props;
  let asset = null;
  let liabilities = null;
  let capital = null;
  let tableData = null;

  let data = [];
  let mappedData = {
    DOC_DATE: "-",
    DOC_DATE_LAST: "-",
    DOC_DATE_BEFORE: "-",
    TOTAL_ASSET: 0,
    TOTAL_ASSET_LAST: 0,
    TOTAL_ASSET_BEFORE: 0,
    LIABILITIES: 0,
    LIABILITIES_LAST: 0,
    LIABILITIES_BEFORE: 0,
  };
  if (isExistData && compInfo !== null) {
    data = [
      ...compInfo["2000001"],
      ...compInfo["2000003"],
      ...compInfo["2000005"],
      ...compInfo["2000007"],
      ...compInfo["2000009"],
      ...compInfo["2000011"],
    ];

    if (compInfo["1000003"].length > 0) {
      for (let item of compInfo["1000003"]) {
        switch (item.item_nm) {
          case "당기결산종료일자":
            mappedData["DOC_DATE"] = util.getDateToFormat(
              item.item_val,
              "YYYY-MM-DD"
            );

            break;
        }
      }

      if (mappedData["DOC_DATE"] !== "-") {
        let date = new Date(mappedData["DOC_DATE"]);
        mappedData["DOC_DATE"] = util.getDateToFormat(date, "YY");
        mappedData["DOC_DATE_LAST"] = mappedData["DOC_DATE"] - 1;
        mappedData["DOC_DATE_BEFORE"] = mappedData["DOC_DATE"] - 2;
      }
    }

    for (let item of data) {
      switch (item.item_nm) {
        case "총자산(당기)":
          mappedData["TOTAL_ASSET"] = Number(item.item_val);
          break;
        case "총자산(전기)":
          mappedData["TOTAL_ASSET_LAST"] = Number(item.item_val);
          break;
        case "총자산(전전기)":
          mappedData["TOTAL_ASSET_BEFORE"] = Number(item.item_val);
          break;
        case "부채(당기)":
          mappedData["LIABILITIES"] = Number(item.item_val);
          break;
        case "부채(전기)":
          mappedData["LIABILITIES_LAST"] = Number(item.item_val);
          break;
        case "부채(전전기)":
          mappedData["LIABILITIES_BEFORE"] = Number(item.item_val);
          break;
      }
    }
    asset = [
      {
        name: `${mappedData["DOC_DATE_BEFORE"]}년`,
        CNT: mappedData["TOTAL_ASSET_BEFORE"],
        key: `year${mappedData["DOC_DATE_BEFORE"]}`,
      },
      {
        name: `${mappedData["DOC_DATE_LAST"]}년`,
        CNT: mappedData["TOTAL_ASSET_LAST"],
        key: `year${mappedData["DOC_DATE_LAST"]}`,
      },
      {
        name: `${mappedData["DOC_DATE"]}년`,
        CNT: mappedData["TOTAL_ASSET"],
        key: `year${mappedData["DOC_DATE"]}`,
      },
    ];
    liabilities = [
      {
        name: `${mappedData["DOC_DATE_BEFORE"]}년`,
        CNT: mappedData["LIABILITIES_BEFORE"],
        key: `year${mappedData["DOC_DATE_BEFORE"]}`,
      },
      {
        name: `${mappedData["DOC_DATE_LAST"]}년`,
        CNT: mappedData["LIABILITIES_LAST"],
        key: `year${mappedData["DOC_DATE_LAST"]}`,
      },
      {
        name: `${mappedData["DOC_DATE"]}년`,
        CNT: mappedData["LIABILITIES"],
        key: `year${mappedData["DOC_DATE"]}`,
      },
    ];
    capital = [
      {
        name: `${mappedData["DOC_DATE_BEFORE"]}년`,
        CNT:
          mappedData["TOTAL_ASSET_BEFORE"] - mappedData["LIABILITIES_BEFORE"],
        key: `year${mappedData["DOC_DATE_BEFORE"]}`,
      },
      {
        name: `${mappedData["DOC_DATE_LAST"]}년`,
        CNT: mappedData["TOTAL_ASSET_LAST"] - mappedData["LIABILITIES_LAST"],
        key: `year${mappedData["DOC_DATE_LAST"]}`,
      },
      {
        name: `${mappedData["DOC_DATE"]}년`,
        CNT: mappedData["TOTAL_ASSET"] - mappedData["LIABILITIES"],
        key: `year${mappedData["DOC_DATE"]}`,
      },
    ];
    tableData = [
      {
        key: "asset",
        headName: "자산",
        current: mappedData["TOTAL_ASSET"],
        currentPer: isFinite(
          mappedData["TOTAL_ASSET"] / mappedData["TOTAL_ASSET_LAST"]
        )
          ? util.addCommas(
              util.getPercent(
                mappedData["TOTAL_ASSET"],
                mappedData["TOTAL_ASSET_LAST"]
              )
            )
          : 100,
        last: mappedData["TOTAL_ASSET_LAST"],
        lastPer: isFinite(
          mappedData["TOTAL_ASSET_LAST"] / mappedData["TOTAL_ASSET_BEFORE"]
        )
          ? util.addCommas(
              util.getPercent(
                mappedData["TOTAL_ASSET_LAST"],
                mappedData["TOTAL_ASSET_BEFORE"]
              )
            )
          : 100,
        before: mappedData["TOTAL_ASSET_BEFORE"],
        beforePer: 0,
      },
      {
        key: "liabilities",
        headName: "부채",
        current: mappedData["LIABILITIES"],
        currentPer: isFinite(
          mappedData["LIABILITIES"] / mappedData["LIABILITIES_LAST"]
        )
          ? util.addCommas(
              util.getPercent(
                mappedData["LIABILITIES"],
                mappedData["LIABILITIES_LAST"]
              )
            )
          : 100,
        last: mappedData["LIABILITIES_LAST"],
        lastPer: isFinite(
          mappedData["LIABILITIES_LAST"] / mappedData["LIABILITIES_BEFORE"]
        )
          ? util.addCommas(
              util.getPercent(
                mappedData["LIABILITIES_LAST"],
                mappedData["LIABILITIES_BEFORE"]
              )
            )
          : 100,
        before: mappedData["LIABILITIES_BEFORE"],
        beforePer: 0,
      },
      {
        key: "capital",
        headName: "자본",
        current: mappedData["TOTAL_ASSET"] - mappedData["LIABILITIES"],
        currentPer: isFinite(
          (mappedData["TOTAL_ASSET"] - mappedData["LIABILITIES"]) /
            (mappedData["TOTAL_ASSET_LAST"] - mappedData["LIABILITIES_LAST"])
        )
          ? util.addCommas(
              util.getPercent(
                mappedData["TOTAL_ASSET"] - mappedData["LIABILITIES"],
                mappedData["TOTAL_ASSET_LAST"] - mappedData["LIABILITIES_LAST"]
              )
            )
          : 100,
        last: mappedData["TOTAL_ASSET_LAST"] - mappedData["LIABILITIES_LAST"],
        lastPer: isFinite(
          (mappedData["TOTAL_ASSET_LAST"] - mappedData["LIABILITIES_LAST"]) /
            (mappedData["TOTAL_ASSET_BEFORE"] -
              mappedData["LIABILITIES_BEFORE"])
        )
          ? util.addCommas(
              util.getPercent(
                mappedData["TOTAL_ASSET_LAST"] - mappedData["LIABILITIES_LAST"],
                mappedData["TOTAL_ASSET_BEFORE"] -
                  mappedData["LIABILITIES_BEFORE"]
              )
            )
          : 100,
        before:
          mappedData["TOTAL_ASSET_BEFORE"] - mappedData["LIABILITIES_BEFORE"],
        beforePer: 0,
      },
    ];
  }

  const headCells = [
    {
      field: "headName",
      headerName: "항목",
      minWidth: 150,
      numeric: false,
      disablePadding: false,
      renderCell: (params) => {
        return (
          <span className="text-truncate text-wrap text-break">
            {params.data}
          </span>
        );
      },
    },
    {
      field: "before",
      headerName: `${mappedData["DOC_DATE_BEFORE"]}년(YoY)`,
      minWidth: 150,
      numeric: false,
      disablePadding: false,
      renderCell: (params) => {
        return (
          <span className="text-truncate text-wrap text-break">
            {util.addCommas(params.data)}({params.currentData.beforePer}%)
          </span>
        );
      },
    },
    {
      field: "last",
      headerName: `${mappedData["DOC_DATE_LAST"]}년(YoY)`,
      minWidth: 150,
      numeric: false,
      disablePadding: false,
      renderCell: (params) => {
        return (
          <span className="text-truncate text-wrap text-break">
            {util.addCommas(params.data)}({params.currentData.lastPer}%)
          </span>
        );
      },
    },
    {
      field: "current",
      headerName: `${mappedData["DOC_DATE"]}년(YoY)`,
      minWidth: 150,
      numeric: false,
      disablePadding: false,
      renderCell: (params) => {
        return (
          <span className="text-truncate text-wrap text-break">
            {util.addCommas(params.data)}({params.currentData.currentPer}%)
          </span>
        );
      },
    },
  ];

  return (
    <div className="mb-5 ">
      <SectionTitle title="재무현황(재무상태표)" />
      <div className="container-fluid m-0 p-0">
        <div className="row m-0 p-0">
          <div
            className={`col-md-6 col-xl-4 ${
              isPrint ? "col-4" : ""
            } border d-flex flex-row justify-content-center align-items-center`}
            style={{ height: "300px" }}
          >
            <MyResponsiveBar
              data={asset}
              title={"자산"}
              colors={["#7f7f7f", "#7f7f7f", "#125186"]}
              isPrint={isPrint}
            />
          </div>
          <div
            className={`col-md-6 col-xl-4 ${
              isPrint ? "col-4" : ""
            } border d-flex flex-row justify-content-center align-items-center`}
            style={{ height: "300px" }}
          >
            <MyResponsiveBar
              data={liabilities}
              title={"부채"}
              colors={["#7f7f7f", "#7f7f7f", "#ff0000"]}
              isPrint={isPrint}
            />
          </div>
          <div
            className={`col-md-6 col-xl-4 ${
              isPrint ? "col-4" : ""
            } border d-flex flex-row justify-content-center align-items-center`}
            style={{ height: "300px" }}
          >
            <MyResponsiveBar
              data={capital}
              title={"자본"}
              colors={["#7f7f7f", "#7f7f7f", "#385723"]}
              isPrint={isPrint}
            />
          </div>
        </div>
        <p className="text-right mb-1">단위 : 백만원</p>
        <div className="border-top border-bottom border-freiscop">
          <TableContainer>
            <Table aria-label="table">
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.field}
                      padding={headCell.disablePadding ? "none" : "normal"}
                      style={{
                        background: "rgba(0,32,96,0.1)",
                        textAlign: "center",
                      }}
                    >
                      {headCell.headerName}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData &&
                  tableData.map((row, index) => {
                    return (
                      <TableRow role="checkbox" key={row.key}>
                        {headCells.map((headCell) => (
                          <TableCell
                            key={headCell.field}
                            padding={
                              headCell.disablePadding ? "none" : "normal"
                            } //패딩 값 부여 여부
                            style={{ textAlign: "center" }}
                          >
                            {headCell.hasOwnProperty("renderCell") // headCell에 "renderCell" 속성 포함여부 확인
                              ? headCell.renderCell({
                                  data: row[headCell.field],
                                  currentData: row,
                                  currentHeader: headCell.field,
                                  headCells: headCells,
                                })
                              : headCell.hasOwnProperty("valueGetter")
                              ? headCell.valueGetter({
                                  data: row[headCell.field],
                                  currentData: row,
                                  currentHeader: headCell.field,
                                  headCells: headCells,
                                })
                              : row[headCell.field]}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

const MyResponsiveBar = ({ data, title, colors, isPrint }) => {
  if (data === null) {
    return <p>{title}데이터가 존재하지 않습니다.</p>;
  }

  const widthProps = isPrint ? { width: 300 } : {};

  return (
    <ResponsiveBar
      {...ChartDefaultOption.ResponsiveBar}
      margin={{ top: 30, right: 40, bottom: 50, left: 40 }}
      data={data}
      keys={["CNT"]}
      indexBy="name"
      colorBy={"indexValue"}
      legends={[]}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: title,
        legendPosition: "middle",
        legendOffset: 32,
      }}
      valueFormat={(v) => {
        return util.addCommas(v);
      }}
      colors={colors}
      labelTextColor={"#ffffff"}
      {...widthProps}
      tooltip={({
        id,
        value,
        formattedValue,
        index,
        indexValue,
        data,
        color,
      }) => (
        <div
          style={{
            padding: 12,
            color: "white",
            background: "#222222",
          }}
        >
          <strong>
            {indexValue} : {util.addCommas(formattedValue)}
          </strong>
        </div>
      )}
    />
  );
};
